import React from "react";
import {Link} from "react-router-dom";
//import React, { PureComponent } from "react";
import "./style.css";
import bg from '../../assets/images/background.svg';


function CadastroX(props) {
  const { text_aviso, text_description, text_btn } = props;

  return (
      <div id="cadastroOK" className='bb' >
        <div className="erro-x dj-bg" style={{ backgroundImage: `url(${bg})` }}>
          {/*
          <img className="xSVG" src={xSVG} alt="" />
          */}
          <h1 className="text-n1 archivo-bold-color-text-54px">{text_aviso}</h1>
          <p className="text-n2 poppins-normal-color-text-16px">{text_description}</p>
          <Link to= "/Login" >
            <div className="boto djbtn">
              <div className="btn-txt valign-text-middle archivo-semi-bold-white-18px">{text_btn}</div>
            </div>
          </Link>
        </div>
       </div>
  );
}


export default CadastroX;
